class TC_Channels_Rows {
    constructor () {
        this.rows = null;
        this.template = $('.calmchristian-channels-genre')[0].outerHTML;
        this.wrapper = $('.calmchristian-channels');
    }

    setRemoteData (remoteData) {
        this.rows = JSON.parse(JSON.stringify(remoteData));
        this.sortRows();
    }

    sortRows () {
        this.rows.sort((rowA, rowB) => {
            return parseInt(rowA.id, 10) - parseInt(rowB.id, 10);
        });
    }

    generateRows (channelsUI) {
        $('.calmchristian-channels-genre').remove();

        for (let i = this.rows.length; i > 0; i--) {
            let rowElement = $(this.template);
            rowElement.attr('data-genre-id', parseInt(this.rows[i - 1].id, 10));
            let heading = rowElement.find('.calmchristian-channels-header');
            let row = this.rows[i - 1];
            heading.text(row.title);
            heading.attr('data-letter', row.title.substr(0, 1));
            this.wrapper.prepend(rowElement);

            setTimeout(() => {
                rowElement.find('.calmchristian-channels-items').remove();

                for (let j = 0; j < this.rows[i - 1].categories.length; j++) {
                    let rowID = parseInt(this.rows[i - 1].id, 10);
                    let categoryID = parseInt(this.rows[i - 1].categories[j], 10);
                    channelsUI.generateCategory(rowID, categoryID);
                }

                if (this.rows[i - 1].categories.length === 1) {
                    rowElement.attr('data-has-only-one-category', 'true');
                }
            }, 0);
        }
    }
}